export type UiMode = 'VALIDATING' | 'DRAFT' | 'EXECUTING' | 'TERMINAL';

export enum InfoTagEnum {
  ALL = 'all',
  TYPE = 'type',
  RESPONSIBLE_PERSON = 'responsible_person',
  ORDERS = 'orders',
}
